export default {
	canAddViewers: (state) => state.viewers.length <= 7
}